import React, { CSSProperties } from 'react';
import nyanCat from '../assets/nyan_cat.gif';

interface IProps {
  style?: CSSProperties;
}

const NyanCat: React.FC<IProps> = ({ style }) => {
  return <img src={nyanCat} style={{ ...catStyle, ...style }} />;
};

const catStyle: CSSProperties = {
  width: '200px',
  margin: '0 auto',
};

export { NyanCat };
